import { napoliAfragola } from "./napoli-afragola";
import { ponteNaviglioGrande } from "./ponte-naviglio-grande";
import { reggioEmilia } from "./reggio-emilia";
import { terzoValico } from "./terzo-valico";

export const hardLevels = [
  napoliAfragola,
  ponteNaviglioGrande,
  reggioEmilia,
  terzoValico,
];
